
// @ts-nocheck

import { defineComponent } from 'vue';
import { nextTick } from 'vue'

import {getParameterByName, ampLogInfo} from './util'

import LayerStateCalifornia from './components/LayerStateCalifornia.vue';
import LayerStateColorado from './components/LayerStateColorado.vue';
import LayerStateConnecticut from './components/LayerStateConnecticut.vue';
import LayerStateUtah from './components/LayerStateUtah.vue';
import LayerStateVirginia from './components/LayerStateVirginia.vue';

import LayerOne from './components/LayerOne.vue';
import LayerTwo from './components/LayerTwo.vue';
import LayerThree from './components/LayerThree.vue';
import LayerNoConsent from './components/LayerNoConsent.vue';

export default defineComponent({
  name: 'App',
  components: {
    LayerOne,
    LayerTwo,
    LayerThree,
    LayerNoConsent,
    LayerStateCalifornia,
    LayerStateColorado,
    LayerStateConnecticut,
    LayerStateUtah,
    LayerStateVirginia

  },

  props: {
    cmpApi: Object,
    tcModel: Object,
    storeTCString: Function,
    storeAcceptAllTCString: Function,
    storeRejectAllTCString: Function,
    reopenLayer: String,
    initialLayer: String,
    initialVisible: Boolean
  },  

  
  data() {
      return {
        view : "close",
        visible : false,
        forcedFixedPosition : false,

        styleObject: {
          margin: '0 auto',
          position: 'absolute',
          top: '10px',
          boxSizing: 'border-box'
        }

      }
    },

  mounted() {

    // @ts-ignore
    this.view = this.initialLayer;

    // @ts-ignore
    this.visible = this.initialVisible;

    // @ts-ignore
    if ( this.view == "layerNoConsent" ) {
      
    // @ts-ignore
        this.styleObject = {
          position: 'absolute',
          top: '50%',
    // @ts-ignore
          left: '50%',
          bottom: 'inherit',
          right: 'inherit',
          transform: 'translate(-50%,-50%)',
          height:'inherit',
          overflow:'hidden'
        };


    }

    // @ts-ignore
    // console.log( "App: mounted() view=" + this.view );
    
    nextTick( () => { this.handleChangeView( this.view ) } );

    // // @ts-ignore
    // this.visible = this.$root.initialLayer == "close"  ? false: true;
    
    // let bodyTag = document.getElementsByTagName("body")[0];

    // // @ts-ignore
    // if ( this.visible)
    //  setTimeout( () => { window.scrollTo(0, 0); }, 250 );
    //   // bodyTag.style.cssText = "height: 100%; overflow: hidden";
  },

  // beforeDestroy() {
  //   console.log( "App: beforeDestroy()" );
  // }
  methods:{

    openCMP( ) : void {
      // console.log("App: openCMP()");
    this.handleChangeView( this.reopenLayer );
  
  },


    handleStoreTCString(  ) : void {

      // console.log( "App: handleStoreTCString()" );

      // @ts-ignore
    this.storeTCString();
    },


  handleStoreAcceptAllTCStringEvent(  ) : void {
       // @ts-ignore
       this.storeAcceptAllTCString();

    },


  handleStoreRejectAllTCString(  ) : void {
       // @ts-ignore
       this.storeRejectAllTCString();

    },


  handleChangeView( viewDestination : string ) : void {
    ampLogInfo( "App: handleChangeView() = > " + viewDestination );
    let bodyTag = document.getElementsByTagName("body")[0];
    // console.log("App handleChangeView():");


    if (viewDestination == "close" ) {
			// bodyTag.style.overflow =  "initial";
			// bodyTag.style.height =  "initial";

    // @ts-ignore
    this.cmpApi.setCmpDisplayStatus( "hidden" );
    // @ts-ignore
    this.cmpApi.setSignalStatus( "ready" );

    this.visible = false;
    }
    else {

			// bodyTag.style.overflow =  "hidden";
      // bodyTag.style.height =  "100%";
      window.scrollTo(0, 0);
     setTimeout( () => { window.scrollTo(0, 0); }, 250 );

    // @ts-ignore
      let setHeight = () => { document.getElementById("__cmp_body").style.maxHeight = ( viewDestination == "layerOne" ) ? "960px" : "98vh"; };


    // @ts-ignore
    if (this.visible)
        setHeight ();
      else {
    // @ts-ignore
    this.visible = true;
        this.$nextTick ( setHeight );
      }
    // @ts-ignore
    this.view = viewDestination;
    this.cmpApi.setCmpDisplayStatus( "visible" );

    // signalStatus must be "not ready" while the CMP UI is visible
    
    // @ts-ignore
    this.cmpApi.setSignalStatus( "not ready" );

  }
  }
}

});
